import React from "react";

const NoSubscriptions = () => {
  return (
    <svg
      width="148"
      height="148"
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="148" height="148" fill="#F6F8FA" />
      <path
        d="M130.236 109.161C130.236 109.161 124.23 107.372 122.427 113.352C124.23 107.372 118.236 105.542 118.236 105.542C118.236 105.542 124.243 107.331 126.046 101.352C124.243 107.331 130.236 109.161 130.236 109.161Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.3665 35.8059C85.9362 36.0673 87.4205 35.0066 87.6818 33.4369C87.9432 31.8673 86.8825 30.3829 85.3129 30.1216C83.7432 29.8603 82.2589 30.9209 81.9975 32.4906C81.7362 34.0603 82.7968 35.5446 84.3665 35.8059Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.372 73.8762C124.942 74.1376 126.426 73.0769 126.688 71.5073C126.949 69.9376 125.888 68.4533 124.319 68.1919C122.749 67.9306 121.265 68.9912 121.003 70.5609C120.742 72.1306 121.803 73.6149 123.372 73.8762Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.1406 98.7567C109.312 77.9378 100.039 47.4355 100.039 47.4355L111.514 51.9559C111.514 51.9559 101.722 85.8756 103.679 115.698L83.1406 98.7567Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M106.578 48.7223C106.578 48.7223 87.8177 33.5787 67.8508 63.5565L81.9547 61.3724L87.3856 55.1115L92.1999 58.1517C92.1999 58.1517 101.882 56.8079 106.578 48.7223Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.287 48.4897C107.287 48.4897 114.781 25.5741 79.6661 17.5549L86.7166 29.9637L94.4981 32.8172L93.3658 38.3974C93.3658 38.3974 98.0605 46.9712 107.287 48.4897Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M106.523 48.6456C106.523 48.6456 129.178 40.3971 138.355 75.227L125.72 68.5911L122.61 60.9084L117.071 62.2248C117.071 62.2248 108.346 57.8165 106.523 48.6456Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.101 47.2997C107.101 47.2997 109.186 23.2802 144.635 29.6622L133.286 38.3159L125.008 37.892L123.864 43.4696C123.864 43.4696 116.185 49.5181 107.101 47.2997Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.0721 118.001C68.901 118.001 68.7268 117.98 68.5535 117.939C67.3664 117.654 66.6356 116.461 66.9212 115.274L74.1581 85.1784C74.4437 83.9929 75.6414 83.2591 76.8234 83.5469C78.0104 83.8318 78.7412 85.0244 78.4556 86.2114L71.2187 116.307C70.9748 117.32 70.0699 118.001 69.0721 118.001Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104 122.122C103.383 122.122 102.769 121.864 102.332 121.362L57.0286 69.2892C56.2279 68.3685 56.3251 66.9729 57.2459 66.1715C58.1645 65.3701 59.5615 65.468 60.3636 66.3887L105.667 118.461C106.468 119.382 106.37 120.778 105.45 121.579C105.032 121.943 104.515 122.122 104 122.122Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.9045 116.269C71.9045 116.269 56.5295 121.466 42.9803 101.084C36.9245 91.9738 31.9949 77.6401 30.7576 73.883C30.5663 73.3019 30.813 72.6733 31.3547 72.389C32.9664 71.5432 37.0751 69.9738 46.204 69.2493C55.2685 68.5299 59.1694 68.8272 60.679 69.0639C61.1779 69.1422 61.5744 69.5135 61.6933 70.0045C62.3708 72.8004 65.1499 82.8489 71.8443 91.3175C82.1766 104.388 97.899 104.015 102.472 103.594C103.657 103.485 104.818 104.247 104.999 105.423C105.111 106.156 104.866 107.019 103.761 107.88C100.921 110.095 71.9045 116.269 71.9045 116.269Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.3095 135.056C75.6578 135.056 75.0132 134.77 74.5766 134.22L26.6151 73.7526C25.8569 72.7958 26.0173 71.4059 26.9733 70.6477C27.9294 69.8881 29.3184 70.0478 30.0782 71.0046L78.0396 131.472C78.7978 132.429 78.6374 133.819 77.6814 134.577C77.2749 134.9 76.7908 135.056 76.3095 135.056Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2691 125.948C29.2605 125.948 28.3491 125.253 28.116 124.227C27.8455 123.037 28.5915 121.854 29.7814 121.583L74.5035 111.418C75.6897 111.149 76.8774 111.893 77.1486 113.084C77.4192 114.274 76.6731 115.458 75.4832 115.729L30.7612 125.893C30.5965 125.931 30.4318 125.948 30.2691 125.948Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9745 125.136C38.8033 125.136 38.6292 125.115 38.4558 125.074C37.2688 124.789 36.538 123.596 36.8236 122.409L44.0605 92.3134C44.3461 91.1264 45.5438 90.3998 46.7257 90.6818C47.9127 90.9667 48.6435 92.1594 48.358 93.3464L41.121 123.442C40.8771 124.455 39.9723 125.136 38.9745 125.136Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="37.5629"
        cy="32.6313"
        r="14.0922"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5605 14.0824V7.94141"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5605 57.3168V51.1758"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.1109 32.625L62.252 32.625"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8726 32.625L19.0137 32.625"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6772 19.5142L55.0195 15.1719"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1049 50.0885L24.4473 45.7461"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6791 45.7436L55.0215 50.0859"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1049 15.1733L24.4473 19.5156"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2578 28.2578L31.9561 30.9564L29.2578 33.6547"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.8672 28.2578L43.1689 30.9564L45.8672 33.6547"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.1019 37.9961H33.0273"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoSubscriptions;
